export function Card({ children, style = {}, glass = false, as: Tag = "div", className = "", ...props }) {
  return (
    <Tag
      {...props}
      className={`fadeUp ${glass ? "glass" : ""} ${className}`.trim()}
      style={{
        background: glass ? undefined : "var(--bg-elevated)",
        borderRadius: "var(--radius-md)",
        border: glass ? undefined : "1px solid var(--border)",
        boxShadow: "var(--shadow-sm)",
        padding: "24px",
        maxWidth: 680,
        margin: "0 auto",
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}

const symbolFor = {
  "💬": "message",
  "📚": "clock",
  "🖼️": "gallery",
  "👤": "person",
  "👩‍🎨": "brush",
  "🎀": "sparkles",
  "🎨": "palette",
  "📅": "calendar",
  "🎉": "seal",
  "👑": "crown",
  "🔐": "lock",
  "🔒": "lock",
  "✉️": "mail",
  "💅": "sparkles",
};

function HeaderIcon({ name }) {
  const common = {
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    fill: "none",
    width: "24",
    height: "24",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { display: "block" },
  };

  switch (name) {
    case "gallery":
      return (
        <svg {...common}>
          <rect x="3.5" y="5" width="17" height="14" rx="2.5" />
          <path d="M7 14.5l2.7-2.9a1 1 0 0 1 1.5 0l1.2 1.3 2-2.2a1 1 0 0 1 1.5 0L19 14.5" />
          <circle cx="9" cy="9" r="1.15" fill="currentColor" stroke="none" />
        </svg>
      );
    case "message":
      return (
        <svg {...common}>
          <path d="M5 6.5h14a2.5 2.5 0 0 1 2.5 2.5v5.5A2.5 2.5 0 0 1 19 17H9l-4.5 3v-3A2.5 2.5 0 0 1 2 14.5V9a2.5 2.5 0 0 1 3-2.5Z" />
          <path d="M7.5 11h9" />
          <path d="M7.5 14h5.5" />
        </svg>
      );
    case "clock":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 7.5V12l3.2 2" />
          <path d="M4.2 5.2v4h4" />
          <path d="M4.6 9.2A8.5 8.5 0 0 1 12 3.5" />
        </svg>
      );
    case "person":
      return (
        <svg {...common}>
          <circle cx="12" cy="8.2" r="3.2" />
          <path d="M5.2 20a6.8 6.8 0 0 1 13.6 0" />
          <circle cx="12" cy="12" r="9.2" />
        </svg>
      );
    case "brush":
      return (
        <svg {...common}>
          <path d="M14.6 4.5 20 9.9" />
          <path d="m13.4 5.7-7.1 7.1a3 3 0 0 0-.8 1.5l-.9 4.6 4.6-.9a3 3 0 0 0 1.5-.8l7.1-7.1a2.1 2.1 0 0 0-3-3Z" />
          <path d="M6.3 14.5 9 17.2" />
        </svg>
      );
    case "palette":
      return (
        <svg {...common}>
          <path d="M12 3.5a8.5 8.5 0 0 0 0 17h1.3a1.9 1.9 0 0 0 1.3-3.3 1.3 1.3 0 0 1 .9-2.2h1.2A4.3 4.3 0 0 0 21 10.7C21 6.7 17 3.5 12 3.5Z" />
          <circle cx="8.3" cy="10" r=".9" fill="currentColor" stroke="none" />
          <circle cx="11.2" cy="7.8" r=".9" fill="currentColor" stroke="none" />
          <circle cx="14.8" cy="8.5" r=".9" fill="currentColor" stroke="none" />
          <circle cx="7.8" cy="13.5" r=".9" fill="currentColor" stroke="none" />
        </svg>
      );
    case "calendar":
      return (
        <svg {...common}>
          <rect x="4" y="5.5" width="16" height="15" rx="2.5" />
          <path d="M8 3.5v4" />
          <path d="M16 3.5v4" />
          <path d="M4 10h16" />
          <path d="m10 15 1.5 1.5L15 13" />
        </svg>
      );
    case "seal":
      return (
        <svg {...common}>
          <path d="M8.3 3.8 12 5.2l3.7-1.4 2 3.4 3.4 2-1.4 3.7 1.4 3.7-3.4 2-2 3.4-3.7-1.4L8.3 22l-2-3.4-3.4-2 1.4-3.7-1.4-3.7 3.4-2Z" />
          <path d="m8.8 12.3 2.2 2.2 4.5-5" />
        </svg>
      );
    case "crown":
      return (
        <svg {...common}>
          <path d="m3.8 8 4.4 3.5L12 5l3.8 6.5L20.2 8l-1.4 10.2H5.2Z" />
          <path d="M5.2 18.2h13.6" />
        </svg>
      );
    case "lock":
      return (
        <svg {...common}>
          <rect x="5" y="10" width="14" height="10" rx="2.5" />
          <path d="M8 10V7.5a4 4 0 0 1 8 0V10" />
          <path d="M12 14.2v2.5" />
        </svg>
      );
    case "mail":
      return (
        <svg {...common}>
          <rect x="3.5" y="6" width="17" height="12" rx="2.5" />
          <path d="m5 8 7 5 7-5" />
        </svg>
      );
    case "sparkles":
    default:
      return (
        <svg {...common}>
          <path d="M12 3.5 13.5 8 18 9.5 13.5 11 12 15.5 10.5 11 6 9.5 10.5 8Z" />
          <path d="M5.5 14.5 6.3 17l2.2.8-2.2.8-.8 2.4-.8-2.4-2.2-.8 2.2-.8Z" />
          <path d="M18 15.5 18.6 17l1.4.5-1.4.5-.6 1.5-.6-1.5-1.4-.5 1.4-.5Z" />
        </svg>
      );
  }
}

function SectionHeaderIcon({ emoji }) {
  return <HeaderIcon name={symbolFor[emoji] || "sparkles"} />;
}

export function SectionHeader({ emoji, title, subtitle }) {
  return (
    <header style={{ textAlign: "center", marginBottom: 28 }}>
      <div
        aria-hidden="true"
        style={{
          width: 52,
          height: 52,
          borderRadius: 16,
          background: "var(--bg-chip)",
          border: "1px solid var(--border)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 13,
          fontWeight: 800,
          color: "var(--accent)",
          margin: "0 auto 14px",
          boxShadow: "var(--shadow-sm)",
        }}
      >
        <SectionHeaderIcon emoji={emoji} />
      </div>
      <h2
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "clamp(24px, 4vw, 32px)",
          fontWeight: 760,
          color: "var(--text)",
          lineHeight: 1.12,
          letterSpacing: 0,
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          style={{
            color: "var(--text-muted)",
            marginTop: 10,
            fontSize: 13.5,
            lineHeight: 1.7,
          }}
        >
          {subtitle}
        </p>
      )}
    </header>
  );
}
